<template>
  <!-- <div class="login-container"> -->
    <!-- <vue-pdf-app
      :pdf="url"
      page-scale='1000'
      ></vue-pdf-app
    > -->
    <!-- :page-scale="20" -->
    <div>
      <vue-pdf-app :config="config" style="position: relative; height:100vh" :pdf="url" :page-scale="20"></vue-pdf-app>
    </div>  
</template>

<script>
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
// import "vue-pdf-app/dist/icons/main.css";
import "vue-pdf-app/dist/icons/main";

export default {
  components: {
    VuePdfApp,
  },
  //   components: { SocialSign },
  data() {
    return {
      config: {
        sidebar: {
    viewThumbnail: false,
    viewOutline: false,
    viewAttachments: false,
  },
  secondaryToolbar: {
    secondaryPresentationMode: false,
    secondaryOpenFile: false,
    secondaryPrint: false,
    secondaryDownload: false,
    secondaryViewBookmark: false,
    firstPage: false,
    lastPage: false,
    pageRotateCw: false,
    pageRotateCcw: false,
    cursorSelectTool: false,
    cursorHandTool: false,
    scrollVertical: false,
    scrollHorizontal: false,
    scrollWrapped: false,
    spreadNone: false,
    spreadOdd: false,
    spreadEven: false,
    documentProperties: false,
  },
        toolbar: {
          toolbarViewerLeft: {
      findbar: false,
      previous: false,
      next: false,
      pageNumber: false,
    },
        toolbarViewerRight: {
      presentationMode: false,
      openFile: false,
      print: true,
      download: false,
      viewBookmark: false,
    },
    toolbarViewerMiddle: {
      zoomOut: false,
      zoomIn: false,
      scaleSelectContainer: false,
    },
  }
      },
      url: "",
      id: "",
      // studyModalitytitle: "",
      token:'',
    };
  },
  created() {
    console.log(this.GLOBAL.BASE_URL)
    this.id = this.$router.currentRoute.query.id;
    // this.studyModalitytitle = this.$router.currentRoute.query.studyModalitytitle;
    // console.log('this.$router.currentRoute.query.',this.$router.currentRoute.query.studyModalitytitle)
    this.pdfurlGet()
    // window.addEventListener('storage', this.afterQRScan)
  },
  methods: {
    pdfurlGet() {
      this.token = sessionStorage.getItem("token");
      this.url =  this.GLOBAL.BASE_URL + 'v1/report/exportReportByStudyId?' + 'token' + '=' + this.token + '&' + 'studyId' + '=' + this.id
      console.log(this.url);
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/pdfconent/index.vue